module.exports = __webpack_public_path__ + "static/img/damodar_baniya.cbdfabdf.jpg";